import * as api from '@gitbook/api-client';

export const INTEGRATIONS_PER_PAGE = 100;
export const INTEGRATIONS_PER_SECTION = 6;

export const INTEGRATION_CATEGORIES = Object.values(api.IntegrationCategory);

export type IntegrationsByCategory = Record<
    api.IntegrationCategory,
    {
        value: api.IntegrationCategory;
        label: string;
        description: string;
        integrations?: Map<string, api.Integration>;
    }
>;

export const INTEGRATIONS_CATEGORY_PROPS: IntegrationsByCategory = {
    [api.IntegrationCategory.Analytics]: {
        value: api.IntegrationCategory.Analytics,
        label: 'Analytics',
        description:
            'Gather insights about your visitors and customers usage of your documentation.',
    },
    [api.IntegrationCategory.Collaboration]: {
        value: api.IntegrationCategory.Collaboration,
        label: 'Collaboration',
        description:
            'Integrate GitBook with your favorite collaboration tools to empower your team.',
    },
    [api.IntegrationCategory.Content]: {
        value: api.IntegrationCategory.Content,
        label: 'Content',
        description: `Extend GitBook's editor with custom content integrations.`,
    },
    [api.IntegrationCategory.Gitsync]: {
        value: api.IntegrationCategory.Gitsync,
        label: 'Git Sync',
        description: 'Synchronize your content with your favorite Git provider.',
    },
    [api.IntegrationCategory.Marketing]: {
        value: api.IntegrationCategory.Marketing,
        label: 'Marketing',
        description:
            'Integrate GitBook with your favorite marketing tools to help grow your platform.',
    },
    [api.IntegrationCategory.VisitorAuth]: {
        value: api.IntegrationCategory.VisitorAuth,
        label: 'Authenticated access',
        description:
            'Control who has access to your published documentation with an authentication provider.',
    },
    [api.IntegrationCategory.Other]: {
        value: api.IntegrationCategory.Other,
        label: 'Other',
        description: 'Integrate GitBook with your favorite tools and applications.',
    },
};
